var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"containerTore",attrs:{"id":"appTore"}},[_c('img',{staticClass:"badgeImg",class:{smallImg: _vm.fooSmallImg},attrs:{"src":'public/white/badge_000'+ _vm.fooBadge +'_Vektor-Smartobjekt.png'}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5efde8d8","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Badges.vue
// module id = 23
// module chunks = 0